"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderDropdownMenu = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var renderDropdownMenu = function (props) {
    if (props.status === 'STANDBY' ||
        ((props.status === 'FETCHED' || props.status === 'FETCHING') &&
            props.searchString === null)) {
        return (React.createElement("div", { className: 'message' }, (0, translation_1.getLocalization)('userFront/admin/activity/project/pleaseTypeProjectName')));
    }
    else if (props.status === 'FETCHED' &&
        props.projects.length === 0 &&
        props.searchString &&
        props.searchString.length > 0) {
        return (React.createElement("div", { className: 'message' }, (0, translation_1.getLocalization)('userFront/admin/activity/project/notFound')));
    }
    else if (props.status === 'FAILED') {
        return (React.createElement("div", { className: 'message' }, (0, translation_1.getLocalization)('userFront/admin/activity/project/failed')));
    }
    else if (props.status === 'FETCHING') {
        return (React.createElement("div", { className: 'message' }, (0, translation_1.getLocalization)('userFront/admin/activity/project/loading')));
    }
    else {
        return props.projects.map(function (x) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: 'project-' + x.id, className: props.value && props.value.id === x.id ? 'selected' : '', onClick: function () {
                props.setSearchString(null);
                props.onSelect(x);
            } }, x.name)); });
    }
};
exports.renderDropdownMenu = renderDropdownMenu;
